/**
 * Named camera / game-state presets used by the headless capture harness.
 * Any module may register one; they are the eyes of the visual-critique loop.
 *
 * A shot fn receives ctx and may position the camera, force weapon state, spawn
 * FX, etc. It must be deterministic and idempotent.
 */

const registry = new Map();

/** @param {string} name @param {(ctx:any)=>void} fn @param {{settle?:number, desc?:string}} [opts] */
export function registerShot(name, fn, opts = {}) {
  registry.set(name, { fn, settle: opts.settle ?? 8, desc: opts.desc ?? '' });
}

export function getShot(name) {
  return registry.get(name);
}

export function listShots() {
  return [...registry.entries()].map(([name, v]) => ({ name, desc: v.desc, settle: v.settle }));
}

/** Point the main camera at a target from a position, and mirror it to the viewmodel camera. */
export function look(ctx, from, at, fov = 80) {
  const cam = ctx.camera;
  cam.position.set(from[0], from[1], from[2]);
  cam.up.set(0, 1, 0);
  cam.lookAt(at[0], at[1], at[2]);
  cam.fov = fov;
  cam.updateProjectionMatrix();
  cam.updateMatrixWorld(true);
  ctx.viewCamera.position.copy(cam.position);
  ctx.viewCamera.quaternion.copy(cam.quaternion);
  ctx.viewCamera.updateMatrixWorld(true);
  return cam;
}
